//Returns em dash if value is null or blank
//Example: "" returns "—"
export default function emDashNull(value) {
	return value ? value : "—";
}
